import {APP_INITIALIZER, ModuleWithProviders, NgModule} from "@angular/core";
import {LocationService} from "./location.service";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import {SettingsService} from "~/app/core/settings.service";
import {ShareService} from "~/app/core/share.service";
import {UserProfileService} from "~/app/core/user-profile-service/user-profile.service";
import {StorageService} from "~/app/core/storage.service";
import {OfferService} from "~/app/core/offer-service/offer.service";
import {NavigationService} from "~/app/core/navigation.service";
import {InteractionService} from "~/app/core/interaction.service";
import {RPCService} from "~/app/core/rpc.service";
import {SuspendService} from "~/app/core/suspend.service";
import {GamificationService} from "~/app/core/gamification.service";
import {TicketService} from "~/app/core/model/ticket-service/ticket.service";
import {NetworkService} from "~/app/core/network.service";
import {CoreService} from "~/app/core/core.service";
import {DialogService} from "~/app/core/dialog.service";
import {MapService} from "~/app/core/maps.service";
import {InstallService} from "~/app/core/install.service";
import {ModalService} from "~/app/core/modal.service";
import {ToastService} from "~/app/core/toast.service";
import {CameraService} from "~/app/core/camera.service";
import {DataStorageService} from "~/app/core/data-storage.service";

export function initializeDataStorage(dataStorage: DataStorageService) {
    console.log("INIT DATA STORAGE");
    return () => dataStorage.waitForReady();
}

@NgModule({})
export class CoreModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: CoreModule,
            providers: [
                DataStorageService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeDataStorage,
                    deps: [DataStorageService],
                    multi: true,
                },
                GamificationService,
                UserProfileService,
                TicketService,
                OfferService,
                LocationService,
                NotificationService,
                SettingsService,
                ApiService,
                NetworkService,
                ShareService,
                StorageService,
                NavigationService,
                InteractionService,
                RPCService,
                SuspendService,
                DialogService,
                MapService,
                InstallService,
                ModalService,
                ToastService,
                CameraService,

                CoreService,
            ]
        };
    }
}
